import React from "react";
import {IProduct} from 'data/interfaces/products';
import styles from './ApproveOrDenyButtons.module.scss';
import {PRODUCT_STATUS_ORDER} from 'data/redux/constants/productsConstants';
import {When} from 'react-if';
import DenyButtonContainer from "data/redux/containers/denyButtonContainer/DenyButtonContainer";
import ApproveButtonContainer from "data/redux/containers/approveButtonContainer/ApproveButtonContainer";

export interface IApproveButton {
  product: IProduct;
}


const ApproveOrDenyButtons = ({product}: IApproveButton) => (
  <When condition={product.status === PRODUCT_STATUS_ORDER}>{() =>
    <div className={styles.approveDenyButtons}>
      <ApproveButtonContainer product={product}/>
      <DenyButtonContainer product={product}/>
    </div>}
  </When>
);

ApproveOrDenyButtons.defaultProps = {
  product: {},
};

export default ApproveOrDenyButtons;
